// these types are all customizable to fit the data format that is required -> iteration is expected
import React, {MutableRefObject} from "react";

/****************************
 *                          *
 *   Selection Area Types   *
 *                          *
 ****************************/

export interface FeatureGeometry {
    type:
        | "Point"
        | "LineString"
        | "Polygon"
        | "MultiPoint"
        | "MultiLineString"
        | "MultiPolygon";
    coordinates: number[] | number[][] | number[][][];
}

// All other visible featues should extend this type
export type IVisibleFeatureType =
    | VisibleFeatureType
    | TIVisibleFeatures
    | QIVisibleFeatures;

export enum VisibleFeatureType {
    other = "other",
}

export enum TIVisibleFeatures {
    bus = "bus",
    transmission = "transmission",
    generator = "generator",
    load = "load",
    thermal = "thermal",
}

export enum QIVisibleFeatures {
    bus = "bus",
    transmission = "transmission",
    generator = "generator",
    iso = "iso",
}

export interface VisibleFeature {
    id: string;
    type: IVisibleFeatureType;
    properties: Record<string, any>;
    geometry: FeatureGeometry;
}

export interface selectedArea {
    bounds: BoundsArray | null;
    features: VisibleFeature[];
    geometry: GeoJSON.Feature | null;
    mode: "Rectangle" | "Circle" | "Lasso" | null;
}

/*****************************
 *                           *
 *   Transmission Insights   *
 *                           *
 *****************************/

export interface TransmissionContextState {
    visibleFeatures: VisibleFeature[];
    selectedArea: {
        bounds: BoundsArray | null;
        features: VisibleFeature[];
    };
}

export interface TransmissionContextValue extends TransmissionContextState {
    updateVisibleFeatures: (features: VisibleFeature[]) => void;
    updateSelectedArea: (
        bounds: [[number, number], [number, number]] | null,
        features: VisibleFeature[]
    ) => void;
    clearSelectedArea: () => void;
}

export interface QueueContextState {
    visibleFeatures: VisibleFeature[];
    allFeatures: VisibleFeature[];
    selectedArea: selectedArea | null;
    selectedGenerationTypes: string[];
    selectedStateTypes: string[];
    selectedCountyTypes: string[];
    selectedClusterTypes: string[];
    currentISOFilter: any;
}

export interface QueueContextValue extends QueueContextState {
    updateVisibleFeatures: (features: VisibleFeature[]) => void;
    updateSelectedArea: (
        bounds: [[number, number], [number, number]] | null,
        features: VisibleFeature[],
        geometry?: GeoJSON.Feature | null,
        mode?: "Rectangle" | "Circle" | "Lasso" | null
    ) => void;
    clearSelectedArea: () => void;
    setSelectedGenerationTypes: (types: string[]) => void;
    setSelectedStateTypes: (types: string[]) => void;
    setSelectedCountyTypes: (types: string[]) => void;
    setSelectedClusterTypes: (types: string[]) => void;
    setCurrentISOFilter: (filter: any) => void;
    resetFilters: () => void;
    generationTypeOptions: any[];
    stateTypeOptions: any[];
    countyTypeOptions: any[];
    clusterTypeOptions: any[];
    isFilterOptionsLoading: boolean;
    filteredIsoData: any[];
    allGenerationTypeValues: string[];
    allStateTypeValues: string[];
    allCountyTypeValues: string[];
    allClusterTypeValues: string[];
    isLoading: boolean;
    mapInstanceRef: MutableRefObject<mapboxgl.Map | null>;
}

export type BoundsArray = [[number, number], [number, number]];

/*****************
 *               *
 *   Map Types   *
 *               *
 *****************/

export type MouseEvent = {
    type: string;
    id: string;
    callback: {
        (
            e: mapboxgl.MapMouseEvent,
            map: mapboxgl.Map,
            setActiveTooltip: React.Dispatch<any>
        ): void;
    };
};
